import 'css-chunk:src/applications/TermsApp/components/BulkTerms/ReviewAndSummary/ReviewAndSummary.scss';export default {
  "ReviewAndSummary": "_ReviewAndSummary_1u4qe_1"
};